import { useContext } from 'react';
import { ApiContext } from './apiContext';

export const useApi = () => {
    const api = useContext(ApiContext);
    return api;
};
